<div class="app-wrapper" *ngIf="access; else noTokensAccess">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                  <core-title-section
                    [title]="'Api Tokens'"
                    [description]="'Here you can manage your tokens to access the API, which will allow you to integrate your Twona account with third party systems such as Zapier.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="button-settings-add">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                  </div>
                </div>

            </header>
            <div class="access-tokens-add" [hidden]="!showForm">
                <settings-access-token-add-form (cancel)="showForm = false" (submit)="onSaved($event)"></settings-access-token-add-form>
            </div>
            <div class="box_default box_white access-tokens-list">
              <div class="loader" [hidden]="status == STATUS_DONE">
                <div class="dimmed" >
                  <div class="dimmed_title"></div>
                  <div class="dimmed_flex">
                    <div class="dimmed_box"></div>
                    <div class="dimmed_subtitle"></div>
                  </div>
                  <div class="dimmed_flex">
                    <div class="dimmed_box"></div>
                    <div class="dimmed_subtitle"></div>
                  </div>
                  <div class="dimmed_flex">
                    <div class="dimmed_box"></div>
                    <div class="dimmed_subtitle"></div>
                  </div>
                </div>
              </div>
              <div class="" *ngIf="status == STATUS_DONE">
                <ng-container *ngIf="accessTokens?.length  > 0; else noTokensAvailable">
                  <h3><span>PERSONAL ACCESS TOKENS</span></h3>
                  <ul>
                      <core-helpers-lists-one-action-list-item
                          *ngFor="let token of accessTokens"
                          [title]="token.name"
                          [subtitle]="token.read_only ? '(Read only)' : ''"
                          [actionText]="token.active? 'Deactivate' : 'Activate'"
                          (actionClick)="remove(token)"
                          [type]="'disabled'"
                      ></core-helpers-lists-one-action-list-item>
                  </ul>
                </ng-container>
                <ng-template #noTokensAvailable>
                  <div class="empty-settings">
                    <core-helpers-box-alert-message-icon
                      [text]="'There are no personal access tokens available.'"
                      [icon]="'warning'"
                    ></core-helpers-box-alert-message-icon>
                  </div>
                </ng-template>
              </div> 
            </div>


        </div>
    </section>
</div>

<ng-template #noTokensAccess>
  <core-helpers-box-http-error [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
</ng-template>
